export const AdobeExperienceManagerIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M1.25 7.58333C1.25 5.36646 1.25 4.25802 1.68143 3.41129C2.06093 2.66648 2.66648 2.06093 3.41129 1.68143C4.25802 1.25 5.36646 1.25 7.58333 1.25H12.4167C14.6335 1.25 15.742 1.25 16.5887 1.68143C17.3335 2.06093 17.9391 2.66648 18.3186 3.41129C18.75 4.25802 18.75 5.36646 18.75 7.58333V12.4167C18.75 14.6335 18.75 15.742 18.3186 16.5887C17.9391 17.3335 17.3335 17.9391 16.5887 18.3186C15.742 18.75 14.6335 18.75 12.4167 18.75H7.58333C5.36646 18.75 4.25802 18.75 3.41129 18.3186C2.66648 17.9391 2.06093 17.3335 1.68143 16.5887C1.25 15.742 1.25 14.6335 1.25 12.4167V7.58333Z"
        fill="#E6001F"
      />
      <path
        d="M4.375 14.375C4.375 14.375 8.26293 5.00245 8.2537 5H8.25369C8.25369 5 8.2537 5 8.2537 5H11.2063L15.625 14.375L12.2876 14.375C12.29 14.38 9.78516 8.62268 9.75376 8.56481C9.74828 8.61501 8.09275 12.4682 8.07276 12.4729H9.85689C9.84878 12.4827 10.6326 14.3571 10.6326 14.375L4.375 14.375Z"
        fill="white"
      />
    </svg>
  );
};
